import { useState, useEffect } from 'react';
import QRCode from 'qrcode';

export default function QRCodeImg({ url, size = 80, style = {} }) {
  const [src, setSrc] = useState('');
  useEffect(() => {
    if (!url) return;
    QRCode.toDataURL(url, { width: size * 2, margin: 1, errorCorrectionLevel: 'H', color: { dark: '#000000', light: '#ffffff' } })
      .then(setSrc)
      .catch(() => {});
  }, [url, size]);
  if (!src) return <div style={{ width: size, height: size, background: '#fff', borderRadius: 2, ...style }} />;
  return <img src={src} width={size} height={size} alt="QR Code" style={{ display: 'block', borderRadius: 2, ...style }} />;
}

export async function downloadQRCode(url, filename = 'qrcode.png', size = 400) {
  const dataUrl = await QRCode.toDataURL(url, { width: size, margin: 2, errorCorrectionLevel: 'H' });
  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
